function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { expressLightBaseTheme, expressDarkBaseTheme } from "./expressThemes";
export const docSiteThemePresetCardKeys = [
    'default',
    'darkMode',
    'retro'
];
/**
 * More official, curated themes that are used in the doc site.
 */ export const docSiteThemePresets = {
    default: {
        appearance: {
            variables: {}
        }
    },
    darkMode: {
        appearance: {
            variables: {
                colorPrimary: '#0085FF',
                colorText: '#C9CED8',
                colorBackground: '#14171D',
                buttonSecondaryColorBackground: '#2B3039',
                buttonSecondaryColorText: '#C9CED8',
                colorSecondaryText: '#8C99AD',
                actionSecondaryColorText: '#C9CED8',
                actionSecondaryTextDecorationColor: '#C9CED8',
                colorBorder: '#2B3039',
                colorDanger: '#F23154',
                badgeNeutralColorBackground: '#1B1E25',
                badgeNeutralColorBorder: '#2B3039',
                badgeNeutralColorText: '#8C99AD',
                badgeSuccessColorBackground: '#152207',
                badgeSuccessColorBorder: '#20360C',
                badgeSuccessColorText: '#3EAE20',
                badgeWarningColorBackground: '#400A00',
                badgeWarningColorBorder: '#5F1400',
                badgeWarningColorText: '#F27400',
                badgeDangerColorBackground: '#420320',
                badgeDangerColorBorder: '#61092D',
                badgeDangerColorText: '#F46B7D',
                offsetBackgroundColor: '#1B1E25',
                formBackgroundColor: '#14171D',
                overlayBackdropColor: 'rgba(0,0,0,0.5)'
            }
        }
    },
    forest: {
        appearance: {
            variables: {
                colorPrimary: '#537D5D',
                colorBackground: '#FFFDF6',
                buttonSecondaryColorBackground: '#DEECD4',
                buttonSecondaryColorText: '#537D5D',
                colorSecondaryText: '#878682',
                colorBorder: '#D6D6D6',
                colorDanger: '#EC5228',
                badgeNeutralColorBackground: '#F5ECD5',
                badgeNeutralColorBorder: '#F5ECD5',
                badgeSuccessColorBackground: '#DEECD4',
                badgeSuccessColorBorder: '#DEECD4',
                badgeSuccessColorText: '#537D5D',
                badgeWarningColorBackground: '#FBDAB1',
                badgeWarningColorBorder: '#FBDAB1',
                badgeWarningColorText: '#751F00',
                badgeDangerColorBackground: '#EC5228',
                badgeDangerColorBorder: '#EC5228',
                badgeDangerColorText: '#FFF',
                offsetBackgroundColor: '#FAF6E9',
                formBackgroundColor: '#FAF6E9',
                borderRadius: '24px'
            }
        }
    },
    retro: {
        appearance: {
            variables: {
                colorPrimary: '#008080',
                colorText: '#000000',
                colorBackground: '#E6E6E6',
                buttonSecondaryColorBackground: '#C3C3C3',
                buttonSecondaryColorText: '#000000',
                colorSecondaryText: '#575757',
                actionSecondaryColorText: '#575757',
                colorBorder: '#575757',
                badgeNeutralColorBackground: '#444',
                badgeNeutralColorBorder: '#444',
                badgeNeutralColorText: '#FFF',
                badgeSuccessColorBackground: '#008080',
                badgeSuccessColorBorder: '#008080',
                badgeSuccessColorText: '#FFF',
                badgeWarningColorBackground: '#DFDF60',
                badgeWarningColorBorder: '#DFDF60',
                badgeWarningColorText: '#69691C',
                badgeDangerColorBackground: '#e35f5f',
                badgeDangerColorBorder: '#e35f5f',
                badgeDangerColorText: '#FFF',
                offsetBackgroundColor: '#FFFFFF',
                borderRadius: '0px',
                overlayBackdropColor: 'rgba(0,0,0,0.7)',
                fontFamily: 'courier'
            }
        }
    }
};
/**
 * Debug themes are used for testing purposes and are not intended for use in the doc site.
 */ export const debugThemePresets = {
    purpleHaze: {
        appearance: {
            variables: {
                colorPrimary: '#414AC3',
                colorBackground: '#e0c3fc',
                badgeNeutralColorBackground: '#F2E8F8',
                badgeNeutralColorBorder: '#FFFFFF',
                badgeSuccessColorBackground: '#8E94F2',
                badgeSuccessColorBorder: '#FFFFFF',
                badgeSuccessColorText: '#FFFFFF',
                badgeWarningColorBackground: '#FFC2E2',
                badgeWarningColorBorder: '#FFFFFF',
                badgeWarningColorText: '#3B3B3B',
                badgeDangerColorBackground: '#EF7A85',
                badgeDangerColorBorder: '#FFFFFF',
                badgeDangerColorText: '#FFFFFF',
                badgeBorderRadius: '24px',
                spacingUnit: '9px'
            }
        }
    },
    swamp: {
        appearance: {
            variables: {
                colorPrimary: '#5AE92B',
                colorText: '#554125',
                colorBackground: '#837411',
                buttonPrimaryColorBackground: '#DAB9B9',
                buttonPrimaryColorBorder: '#F00000',
                buttonPrimaryColorText: '#000000',
                buttonSecondaryColorBackground: '#025F08',
                buttonSecondaryColorText: '#000000',
                badgeNeutralColorBackground: '#638863',
                badgeNeutralColorText: '#28D72A',
                fontFamily: 'fantasy'
            }
        }
    },
    protanopia: {
        appearance: {
            variables: {
                colorPrimary: '#0969DA',
                colorText: '#24292f',
                colorBackground: '#FFFFFF',
                buttonPrimaryColorBackground: '#0969DA',
                buttonPrimaryColorBorder: 'rgba(27,31,36,0.15)',
                buttonPrimaryColorText: '#FFFFFF',
                buttonSecondaryColorBackground: '#F6F8FA',
                buttonSecondaryColorBorder: 'rgba(3, 4, 4, 0.15)',
                buttonSecondaryColorText: '#24292f',
                colorSecondaryText: '#57606a',
                actionPrimaryColorText: '#0969DA',
                actionSecondaryColorText: '#6E7781',
                formAccentColor: '#0969DA',
                colorDanger: '#B35900',
                badgeNeutralColorBorder: '#8C959f',
                badgeNeutralColorText: '#6E7781',
                badgeSuccessColorBorder: '#218BFF',
                badgeSuccessColorText: '#0969DA',
                badgeWarningColorBorder: '#D4A72C',
                badgeWarningColorText: '#BF8700',
                badgeDangerColorBorder: '#DD7815',
                badgeDangerColorText: '#b35900',
                spacingUnit: '8px'
            }
        }
    },
    windows95: {
        appearance: {
            variables: {
                colorPrimary: '#0000C8',
                colorBackground: '#C0C0C0',
                buttonPrimaryColorBorder: '#EFEFEF',
                buttonSecondaryColorBackground: '#C0C0C0',
                buttonSecondaryColorBorder: '#EFEFEF',
                buttonSecondaryColorText: '#000000',
                actionPrimaryColorText: '#2d49eb',
                badgeNeutralColorBackground: '#808080',
                badgeNeutralColorText: '#FFFFFF',
                badgeSuccessColorBackground: '#0000C8',
                badgeSuccessColorText: '#FFFFFF',
                badgeWarningColorBackground: '#9A9A66',
                badgeWarningColorBorder: '#C5C5C5',
                badgeWarningColorText: '#FFFFFF',
                badgeDangerColorBackground: '#FF0000',
                badgeDangerColorBorder: '#C5C5C5',
                badgeDangerColorText: '#FFFFFF',
                borderRadius: '0px',
                fontFamily: 'MS Sans Serif'
            }
        }
    },
    cloud: {
        appearance: {
            variables: {
                colorPrimary: '#61B8FF',
                colorText: '#292929',
                colorSecondaryText: '#969696',
                colorBorder: '#D5E9FB',
                colorDanger: '#E60532',
                badgeNeutralColorBackground: '#F1F9F9',
                badgeNeutralColorBorder: '#F1F9F9',
                badgeSuccessColorBackground: '#A2D3FB',
                badgeSuccessColorBorder: '#A2D3FB',
                badgeSuccessColorText: '#051C2E',
                badgeWarningColorBackground: '#F9F3DC',
                badgeWarningColorBorder: '#F9F3DC',
                badgeDangerColorBackground: '#F9E6E6',
                badgeDangerColorBorder: '#F9E6E6',
                offsetBackgroundColor: '#C9EEFD',
                formBackgroundColor: '#DDF4FD',
                borderRadius: '24px',
                spacingUnit: '14px',
                fontFamily: 'Chalkboard',
                headingXlFontWeight: '600',
                headingLgFontWeight: '600',
                headingMdFontWeight: '600',
                headingSmFontWeight: '600',
                headingXsFontWeight: '600',
                bodyMdFontWeight: '300',
                bodySmFontWeight: '300',
                labelMdFontWeight: '300',
                labelSmFontWeight: '300'
            }
        }
    },
    oceanBreeze: {
        appearance: {
            variables: {
                colorPrimary: '#15609E',
                colorBackground: '#EAF6FB',
                buttonSecondaryColorBorder: '#2C93E8',
                buttonSecondaryColorText: '#2C93E8',
                badgeNeutralColorText: '#5A621D',
                badgeSuccessColorText: '#2A6093',
                borderRadius: '23px'
            }
        }
    },
    hotDog: {
        appearance: {
            variables: {
                colorPrimary: '#FF2200',
                colorText: '#000000',
                colorBackground: '#FFFF00',
                buttonPrimaryColorBackground: '#C6C6C6',
                buttonPrimaryColorBorder: '#1F1F1F',
                buttonPrimaryColorText: '#1F1F1F',
                buttonSecondaryColorBackground: '#C6C6C6',
                buttonSecondaryColorBorder: '#1F1F1F',
                colorSecondaryText: '#000000',
                badgeWarningColorBackground: '#F9A443',
                badgeDangerColorText: '#991400',
                offsetBackgroundColor: '#FF2200',
                borderRadius: '0px',
                fontFamily: 'MS Sans Serif'
            }
        }
    },
    graphicDesign: {
        appearance: {
            variables: {
                colorPrimary: '#D60E00',
                colorText: '#FF0000',
                colorBackground: '#E8E8E8',
                buttonSecondaryColorBackground: '#67CC24',
                colorSecondaryText: '#4FA244',
                actionSecondaryColorText: '#B62F2F',
                colorBorder: '#04FF00',
                badgeSuccessColorText: '#6B0505',
                badgeWarningColorText: '#73FF00',
                badgeDangerColorText: '#37FF00',
                borderRadius: '24px',
                formBorderRadius: '9px',
                fontFamily: '"Papyrus"',
                headingXlFontSize: '30px',
                headingXlFontWeight: '800',
                bodySmFontWeight: '800'
            }
        }
    },
    jazzCup: {
        appearance: {
            variables: {
                colorPrimary: '#2C1679',
                colorText: '#2C1679',
                buttonSecondaryColorBackground: '#0CCDDB',
                buttonSecondaryColorText: '#2C1679',
                colorSecondaryText: '#871CA1',
                actionPrimaryColorText: '#0CCDDB',
                colorBorder: '#871CA1',
                offsetBackgroundColor: '#FFFFFF',
                fontFamily: '"Chalkboard"'
            }
        }
    },
    link: {
        appearance: {
            variables: {
                colorPrimary: '#1C3944',
                colorText: '#1C3944',
                buttonPrimaryColorBackground: '#33DCB3',
                buttonPrimaryColorBorder: '#33DCB3',
                buttonPrimaryColorText: '#1C3944',
                colorSecondaryText: '#485B61',
                actionPrimaryColorText: '#33DCB3',
                badgeNeutralColorBackground: '#DEFECC',
                badgeNeutralColorText: '#1C3944',
                badgeSuccessColorBackground: '#B4FEE1',
                badgeSuccessColorBorder: '#C0D7CD',
                badgeSuccessColorText: '#1C3944',
                borderRadius: '5px',
                spacingUnit: '9px',
                fontFamily: '"Nuckle",sans-serif'
            }
        }
    },
    platform: {
        appearance: {
            variables: {
                colorPrimary: '#000000',
                colorBorder: '#EDEDED',
                formHighlightColorBorder: '#4F4F4F',
                formBackgroundColor: '#F5F5F5',
                formBorderRadius: '0px',
                spacingUnit: '10px',
                headingXlFontWeight: '900',
                headingMdFontWeight: '600',
                headingSmFontWeight: '600',
                headingXsFontWeight: '600',
                labelMdFontWeight: '400',
                labelMdTextTransform: 'uppercase',
                labelSmFontWeight: '500',
                labelSmTextTransform: 'uppercase'
            }
        }
    },
    retroGreen: {
        appearance: {
            variables: {
                colorPrimary: '#E29D08',
                colorText: '#DEC93F',
                colorBackground: '#0A3312',
                buttonPrimaryColorText: '#E63900',
                buttonSecondaryColorBackground: '#0B755A',
                buttonSecondaryColorBorder: '#219C7D',
                buttonSecondaryColorText: '#E4EAB8',
                colorSecondaryText: '#E2DF8D',
                actionPrimaryTextDecorationLine: 'underline',
                actionPrimaryTextDecorationStyle: 'double',
                actionSecondaryTextDecorationStyle: 'double',
                badgeNeutralColorText: '#9D348A',
                badgeWarningColorText: '#DA6110',
                badgeDangerColorText: '#FF0000',
                borderRadius: '24px',
                overlayBackdropColor: '#2D2A2A',
                overlayZIndex: 1000,
                spacingUnit: '10px',
                fontFamily: '"Charter"',
                headingXlTextTransform: 'uppercase',
                headingLgTextTransform: 'uppercase',
                headingMdTextTransform: 'uppercase',
                headingSmFontSize: '18px',
                headingSmTextTransform: 'lowercase',
                headingXsFontSize: '16px',
                headingXsTextTransform: 'lowercase',
                labelMdFontSize: '18px',
                labelMdFontWeight: '800',
                labelMdTextTransform: 'uppercase',
                labelSmFontSize: '14px',
                labelSmTextTransform: 'lowercase'
            }
        }
    },
    spooky: {
        appearance: {
            variables: {
                colorPrimary: '#FF6E00',
                colorText: '#FFFFF0',
                colorBackground: '#000000',
                buttonPrimaryColorBackground: '#FF6E00',
                buttonPrimaryColorBorder: '#000000',
                buttonPrimaryColorText: '#000000',
                buttonSecondaryColorBackground: '#FFA500',
                badgeSuccessColorBackground: '#FF6E00',
                badgeSuccessColorText: '#FFFFFF',
                badgeDangerColorBackground: '#FDE2E1',
                badgeWarningColorBackground: '#FFF4E5',
                badgeNeutralColorBackground: '#E8F4FD',
                borderRadius: '8px',
                colorBorder: '#000000',
                fontFamily: 'Comic Sans MS, Charcoal, sans-serif'
            }
        }
    },
    // These express themes are designed to mimic express and make debugging easier. Keep in sync with manage/frontend/src/connect/expressApp/hostedDashboard/context/ThemeContext/ThemeContext.tsx
    expressDarkMode: {
        appearance: {
            variables: _object_spread_props(_object_spread({}, expressDarkBaseTheme), {
                colorPrimary: '#27AE60'
            })
        }
    },
    expressLightMode: {
        appearance: {
            variables: _object_spread_props(_object_spread({}, expressLightBaseTheme), {
                colorPrimary: '#27AE60',
                buttonPrimaryColorText: '#FFFFFF'
            })
        }
    }
};
export const allThemePresets = _object_spread({}, docSiteThemePresets, debugThemePresets);

//# sourceMappingURL=themePresets.js.map